import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./library.css";

export default function LibraryCategoryAdd() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [name,   setName]   = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name.trim()) return alert("Enter category name");
    try {
      setSaving(true);
      await API.post(
        "/school-admin/library/categories/",
        { name },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      navigate("/school-admin/library/categories");
    } catch (err) { console.error(err); alert("Failed to add category"); }
    finally { setSaving(false); }
  };

  return (
    <div className="lb-page">

      {/* ══ HERO ══ */}
      <div className="lb-hero">
        <div className="lb-hero-left">
          <div className="lb-hero-icon">🗂</div>
          <div>
            <h2 className="lb-hero-title">Add Category</h2>
            <p className="lb-hero-sub">Create a new book category for the library</p>
          </div>
        </div>
        <div className="lb-hero-right">
          <button className="lb-btn-back" onClick={() => navigate("/school-admin/library/categories")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSave}>
        <div className="lb-form-card">
          <p className="lb-form-title">Category Details</p>

          <div className="lb-field" style={{ marginBottom:"24px" }}>
            <label>Category Name *</label>
            <input
              required
              placeholder="e.g. Science, Story Books, Reference, Fiction"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <button type="submit" className="lb-btn-submit" disabled={saving}>
            {saving
              ? <><div className="lb-spinner"></div> Saving…</>
              : "✓ Add Category"
            }
          </button>
        </div>
      </form>

    </div>
  );
}
